/**
 * Volume math, pulled out as pure functions so "mute really disconnects" and
 * "volumes clamp" are unit-testable without a real `GainNode`
 * (`test/audio/gain.test.ts`). `AudioEngine` calls these to compute what it
 * writes to a real `GainNode.gain.value`; nothing here touches audio nodes.
 */

/** Clamp to the `[0, 1]` a `GainNode.gain.value` accepts. `NaN` (or any non-finite input) clamps to `0` — silence is the safe failure. */
export function clampVolume(volume: number): number {
  if (!Number.isFinite(volume)) return 0;
  return Math.min(1, Math.max(0, volume));
}

/** The gain to actually apply: `0` whenever `enabled` is false, regardless of `volume` — mute is a real disconnect, not a very quiet volume. */
export function effectiveGain(enabled: boolean, volume: number): number {
  return enabled ? clampVolume(volume) : 0;
}
